export const colorMap = {
  'creator-black': '#010101',
  'true-blue': '#0659D8',
  'vampire-black': '#070505',
  'smoky-black': '#0E0E0E',
  'chinese-black': '#111111',
  'raisin-black': '#222222',
  'dark-charcoal': '#333333',
  'outer-space': '#444444',
  'jelly-bean-blue': '#457F97',
  zomp: '#45A580',
  'ultramarine-blue': '#475FF7',
  turquoise: '#47D7F7',
  'granite-gray': '#666666',
  'bud-green': '#78AD51',
  'taupe-gray': '#888888',
  'spanish-gray': '#999999',
  'shiny-shamrock': '#4FA580',
  purple: '#A328FF',
  'acid-green': '#B9B51F',
  'medium-violet-red': '#B2088A',
  'light-pastel-purple': '#B7A1DD',
  'steel-pink': '#CB2AC0',
  'chinese-silver': '#CCCCCC',
  'electric-lime': '#CCFF00',
  persimmon: '#E64F00',
  'royal-orange': '#EA9746',
  crayola: '#EBB6D2',
  maize: '#EEC655',
  'rose-pink': '#F670DB',
  'international-orange': '#FF4C01',
  'lemon-yellow': '#FCED4A',
  'red-orange': '#FF4601',
  'persian-pink': '#FF75BF',
  'princess-perfume': '#FC88CA',
  'naples-yellow': '#FFDC5F',
  'radical-red': '#FF2B6C',
  'united-nations-blue': '#627EEA',
  'lavender-indigo': '#8247E5',
  white: '#FFFFFF',
  'forest-green': '#004E1D',
  'june-bud': '#A5DB4E',
  'tufts-blue': '#4583DC',
  'st-patrick-blue': '#15297A',
  'cornflower-blue': '#6D81E4',
  'light-cobalt-blue': '#899AE9',
  coinbase: '#1652F0',
  'blue-violet': '#7A40E5',
  'dark-orchid': '#992FCE',
  'tezos-blue': '#709AFF',
  'blue-crayola': '#2D7DF8',
  'japanese-indigo': '#2E374B',
  'lapis-lazuli': '#2C6593',
  'cyan-azure': '#4D81AA',
  rudy: '#FF0420',
  'dark-candy-apple-red': '#A60000',
  'blue-base': '#033DFF',
  lavender: '#E5EAFC',
  'audius-1': '#CC0FE0',
  'audius-2': '#7E1BCC',
  'audius-3': '#2C0F93',
  'showtime-1': '#C8820E',
  'showtime-2': '#EFA61D',
  'showtime-3': '#FACE52',
  'showtime-4': '#FBF6D3',
  'friendtech-1': '#2ECFF6',
  'friendtech-2': '#7059FB',
  'friendtech-3': '#AC50EF',
  'soundxyz-1': '#DE32A6',
  'soundxyz-2': '#3A2339',
  'soundxyz-3': '#37677E',
  'zora-1': '#FFEEF8',
  'zora-2': '#E3C5EA',
  'zora-3': '#6483E6',
  'zora-4': '#3C6EE4',
  'zora-5': '#3967D7',
  'zora-6': '#261118',
  'zora-7': '#7F4E2C',
  'plump-purple': '#673EBB',
  fandango: '#A83C96',
  ruber: '#DC4974',
  'sandy-brown': '#E89D60',
  'rainbow-1': '#881AB3',
  'rainbow-2': '#E433D3',
  'rainbow-3': '#E9642C',
  'rainbow-4': '#F4E24B',
  'rainbow-5': '#6EED47',
  'rainbow-6': '#6BE6C6',
  'rainbow-7': '#23567F',
  'trust-1': '#2C63BF',
  'trust-2': '#295BA8',
  walletconnect: '#5095F7',
  'avalanche-1': '#EB2C2E',
  'avalanche-2': '#B13232',
  'poap-1': '#B5AEFF',
  'poap-2': '#5E58A5',
  discord: '#7289da',
  'dark-pink': '#EE1D52',
  'mirror-1': '#E0F1FF',
  'mirror-2': '#0A7CFF',
  'mirror-3': '#007AFF',
  'farcaster-1': '#8A63D2',
  'farcaster-2': '#835DC4',
  'blast-1': '#FCFC03',
  'blast-2': '#FCFDC7',
};
